import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { KineticHeading } from "@/components/motion/KineticHeading";
import ProductCard from "@/components/site/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const filtered = active === "all" ? products : products.filter((p) => p.category === active);

  return (
    <div className="pt-36 pb-28 px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto">
      <Seo title="Shop" description="Browse the full Equine Evolve collection — handcrafted gold jewellery, luxury candles and signature home pieces." />
      <Reveal>
        <p className="ee-overline mb-4">The Boutique</p>
        <KineticHeading as="h1" text="Shop the Collection" className="font-display text-5xl md:text-7xl tracking-tight flex flex-wrap" stagger={0.08} />
      </Reveal>

      <div className="flex flex-wrap gap-3 mt-12 mb-14">
        <button
          data-testid="filter-all"
          onClick={() => setActive("all")}
          className={`px-6 py-2 text-sm uppercase tracking-[0.12em] border transition-colors ${
            active === "all" ? "bg-[#D4AF37] text-[#0C0A09] border-[#D4AF37]" : "ee-hairline text-[#A8A29E] hover:text-[#D4AF37]"
          }`}
        >
          All
        </button>
        {cats.map((c) => (
          <button
            key={c.slug}
            data-testid={`filter-${c.slug}`}
            onClick={() => setActive(c.slug)}
            className={`px-6 py-2 text-sm uppercase tracking-[0.12em] border transition-colors ${
              active === c.slug ? "bg-[#D4AF37] text-[#0C0A09] border-[#D4AF37]" : "ee-hairline text-[#A8A29E] hover:text-[#D4AF37]"
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="shop-grid">
        {filtered.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.1}>
            <ProductCard product={p} index={i} />
          </Reveal>
        ))}
      </div>
    </div>
  );
}
